module.exports = __webpack_public_path__ + "static/media/upload_product_icon.cda7bb0b.svg";